module.exports = __webpack_public_path__ + "static/media/travel-sample-image-1.2afec6dc.png";